import { useDispatch } from 'react-redux';
import * as React from 'react';
import { trackAppRouteEvent } from '@/actions/trackEvent';
import * as AnalyticEvents from '@/utils/analytics';
import { ReleaseCalendar } from '@/components/ReleaseCalendar';
import { AppComponentProps } from '@/typescriptHelpers';
import { useTrackPageView } from '@/helpers/trackingHelpers';

const AppReleaseCalendar: React.FC<AppComponentProps> = (props: AppComponentProps) => {
    const dispatch = useDispatch();

    React.useEffect(() => {
        dispatch(
            trackAppRouteEvent({
                orgId: props.orgId,
                appId: props.appId,
                eventName: AnalyticEvents.Event.ViewAppReleaseCalendar,
            }),
        );
    }, []);

    useTrackPageView('Release schedule');

    return <ReleaseCalendar orgId={props.orgId} appId={props.appId} />;
};

export default AppReleaseCalendar;
